import { num } from "@/lib/format";

const BASE_INPUT =
  "w-full h-13 px-4 py-3 rounded-xl border border-stone-200 bg-white text-stone-900 text-base focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition-colors";

export function Field({ label, help, error, children, htmlFor }) {
  return (
    <div>
      <label htmlFor={htmlFor} className="block text-sm font-semibold text-stone-700 mb-1.5">{label}</label>
      {children}
      {help && !error && <p className="text-xs text-stone-500 mt-1">{help}</p>}
      {error && <p className="text-xs text-rose-600 mt-1" data-testid={`${htmlFor}-error`}>{error}</p>}
    </div>
  );
}

export function CurrencyInput({ id, value, onChange, placeholder = "0", ...rest }) {
  return (
    <div className="relative">
      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400 font-medium">$</span>
      <input
        id={id}
        data-testid={id}
        type="text"
        inputMode="decimal"
        autoComplete="off"
        className={`${BASE_INPUT} pl-8`}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        {...rest}
      />
    </div>
  );
}

export function PercentInput({ id, value, onChange, ...rest }) {
  return (
    <div className="relative">
      <input
        id={id}
        data-testid={id}
        type="text"
        inputMode="decimal"
        autoComplete="off"
        className={`${BASE_INPUT} pr-9`}
        value={value}
        placeholder="7.5"
        onChange={(e) => onChange(e.target.value)}
        {...rest}
      />
      <span className="absolute right-4 top-1/2 -translate-y-1/2 text-stone-400 font-medium">%</span>
    </div>
  );
}

export function TermSelect({ id, value, onChange }) {
  return (
    <select id={id} data-testid={id} className={BASE_INPUT} value={value} onChange={(e) => onChange(e.target.value)}>
      {[24, 36, 48, 60, 72, 84].map((t) => (
        <option key={t} value={t}>{t} months</option>
      ))}
    </select>
  );
}

export const CREDIT_OPTIONS = [
  { score: 760, label: "Excellent (720+)" },
  { score: 700, label: "Good (670–719)" },
  { score: 640, label: "Fair (620–669)" },
  { score: 580, label: "Building (below 620)" },
];

export function CreditSelect({ id, value, onChange }) {
  return (
    <select id={id} data-testid={id} className={BASE_INPUT} value={value} onChange={(e) => onChange(e.target.value)}>
      {CREDIT_OPTIONS.map((c) => (
        <option key={c.score} value={c.score}>{c.label}</option>
      ))}
    </select>
  );
}

export function BodySelect({ id, value, onChange }) {
  return (
    <select id={id} data-testid={id} className={BASE_INPUT} value={value} onChange={(e) => onChange(e.target.value)}>
      {["Sedan", "SUV", "Truck", "Coupe", "Hatchback", "Minivan", "Van", "EV"].map((b) => (
        <option key={b} value={b}>{b}</option>
      ))}
    </select>
  );
}

export { num };
